export default {
  menuItems: {
    selectAll: {
      tooltip: "全选 (ctrl+A/command+A)",
    },
    verticalArrange: {
      tooltip: "纵向排列（只支持单列）",
    },
    backToCenter: {
      tooltip: "回到中心",
    },
    previousStep: {
      tooltip: "上一步 (ctrl+Z/command+Z)",
    },
    nextStep: {
      tooltip: "下一步 (ctrl+F/command+F)",
    },
    shortcutKeys: {
      tooltip: "用户帮助",
    },
    addressExpand: {
      tooltip: "地址展开",
    },
    addressCollapse: {
      tooltip: "地址收起",
    },
    // 排序子菜单
    sortSubmenu: {
      globalSort: "全局排序",
      centerSort: "中心排序",
      verticalSort: "纵向排列",
    },
  },
};
